import * as React from "react";
const SvgArrowDownIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3 4.5L6 7.5L9 4.5", stroke: "#3C3F44", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowDownIcon;
